/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";

/** Component */
import { Table, TableHead, TableRow, TableBody, TableCell } from "@material-ui/core";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Hook */
import { useTranslation } from "react-i18next";
import moment from "moment";

/** Init Header */

const tblHeaderEn = ["Product Code", "Quantity", "Unit Price/ (USD/BBL)", "Amount (USD)"];
const tblHeaderVn = ["Mã mặt hàng", "KGM", "US Barels", "Đơn giá/ (USD/BBL)", "Trị giá (USD)"];

const FormCIForShipProforma = ({ data = "", onCheckbox, onCheckAll, onChange, isPrint }) => {
  const [selectedProductIndex, setSelectedProductIndex] = useState(-1);

  const renderTable = () => {
    if (data.ciproducts?.length)
      return (
        <Table aria-label="spanning table" size="small" border={1}>
          <TableHead>
            <TableRow>
              {tblHeaderEn.map((item, id) => (
                <TableCell key={id} padding="checkbox" style={{ fontWeight: "bold" }} align="center" colSpan={id == 1 ? 2 : 1}>
                  {item.toUpperCase()}
                </TableCell>
              ))}

              {!isPrint && (
                <TableCell rowSpan={2} padding="checkbox" align="center" style={{ padding: 3, border: "1px solid gray", whiteSpace: "nowrap", display: onCheckbox ? "" : "none" }}>
                  <Button variant="contained" color="secondary" onClick={onCheckAll}>
                    Select all
                  </Button>
                </TableCell>
              )}
            </TableRow>
            <TableRow>
              {tblHeaderVn.map((item, id) => (
                <TableCell key={id} padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center">
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.ciproducts.map((item, index) => (
              <TableRow
                key={index}
                onClick={(e) => {
                  if (!onChange) return;
                  e.stopPropagation(true);
                  setSelectedProductIndex(index);
                }}
                style={{ cursor: onChange ? "pointer" : "" }}
              >
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                  {27101981}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {item.kg !== undefined ? item.kg?.toLocaleString() : item.gallon?.toLocaleString()}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {Math.round(item.quantity)?.toLocaleString()}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {item.price ? Intl.NumberFormat("ja-JP", { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(item.price) : "-"}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.amount)}
                </TableCell>
                {Boolean(data.id == undefined) && (
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                    <Checkbox
                      disabled={item.period == "loading"}
                      style={{ display: onCheckbox ? "" : "none" }}
                      onClick={(e) => e.stopPropagation()}
                      checked={item.isCreateBK || false}
                      onChange={(e, value) => onCheckbox(index, value)}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
            <TableRow>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center">
                Total
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="right">
                {data?.ciproducts[0].kg !== undefined
                  ? data?.ciproducts
                      .filter((i) => i.isCreateBK !== false)
                      .reduce((p, c) => p + c.kg, 0)
                      ?.toLocaleString()
                  : data?.ciproducts
                      .filter((i) => i.isCreateBK !== false)
                      .reduce((p, c) => p + c.gallon, 0)
                      ?.toLocaleString()}
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="right">
                {data?.ciproducts
                  .filter((i) => i.isCreateBK !== false)
                  .reduce((p, c) => p + c.quantity, 0)
                  ?.toLocaleString()}
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} />
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="right">
                {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2 }).format(data?.ciproducts.filter((i) => i.isCreateBK !== false).reduce((p, c) => p + c.amount, 0))}
              </TableCell>
              {Boolean(onCheckbox) && <TableCell padding="checkbox" align="center" style={{ border: "1px solid gray", fontWeight: "bold" }}></TableCell>}
            </TableRow>
          </TableBody>
        </Table>
      );
  };
  if (data)
    return (
      <div id="civiewer" style={{ margin: "20px auto", padding: "0px 30px" }}>
        <table width="100%" className="mt-1 pb-1" style={{ fontSize: 14 }}>
          <tbody>
            <tr>
              <td colSpan={4}>
                <div style={{ position: "relative", marginBottom: 20 }}>
                  <img alt="" src="/logoP2.png" width="75px" style={{ position: "absolute", left: 75 }} />
                  <div align="center" style={{ width: "100%", color: "#071b63", fontWeight: 700, fontSize: 22, textTransform: "uppercase" }}>
                    Proforma Invoice
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td></td>
              <td align="right">
                <div style={{ width: 300 }} align="left">
                  No./Số: {data.code}
                </div>
              </td>
            </tr>
            <tr>
              <td></td>
              <td align="right">
                <div style={{ width: 300 }} align="left">
                  Date/Ngày: {data.effective_time && moment(data.effective_time).format("MMM DD, YYYY")}
                </div>
              </td>
            </tr>
            <tr>
              <td></td>
              <td align="right">
                <div style={{ width: 300 }} align="left">
                  Ref/Tham chiếu: {data.note.split(/<[^>]*>/).join("")}
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Seller/Người bán:</td>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>PETROLIMEX AVIATION., JSC</td>
            </tr>
            <tr>
              <td></td>
              <td style={{ textAlign: "left" }}>Floor 6, Mipec Tower, 229 Tay Son Str. , Dong Da Dist. , Hanoi, Vietnam</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Buyer/Người mua:</td>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>{data.customer?.rpl_ci ? data.customer?.fullname : data.customer?.name}</td>
            </tr>
            <tr hidden={!data.customer.address}>
              <td style={{ textAlign: "left", fontWeight: "bold" }}></td>
              <td style={{ textAlign: "left" }}>{data.customer.address}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Means of transport/Phương tiện:</td>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>{data?.ciproducts[0].vessel}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>From - To (Từ - Đến):</td>
              <td style={{ textAlign: "left" }}>NHA BE TERMINAL PORT - PHUM KHSOM, CAMBODIA</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Product/Mặt hàng:</td>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Jet A-1</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Delivery term/Giao hàng:</td>
              <td style={{ textAlign: "left" }}>D.A.P - PHUM KHSOM, CAMBODIA</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Contract No/Hợp đồng:</td>
              <td style={{ textAlign: "left" }}>{data?.ciproducts[0].bl}</td>
            </tr>
            {/* Render Table here */}
            <tr>
              <td colSpan={2}>{renderTable()}</td>
            </tr>
            <tr style={{ height: 150, alignContent: "end" }}>
              <td></td>
              <td align="center">
                <b>PETROLIMEX AVIATION</b>
              </td>
            </tr>
            <tr />
            <tr align="left">
              <td colSpan={2}>
                <b>NOTE/Lưu ý: </b>
              </td>
            </tr>
            <tr align="left">
              <td colSpan={2}>
                This Proforma invoice only used for purpose of Custom clearance and other purposes concerning the registration of product wherever it may be registered, not for official payment of the
                amount herein stated.
              </td>
            </tr>
            <tr align="left">
              <td colSpan={2}>
                <i>Hóa đơn tạm tính này chỉ được sử dụng để làm thủ tục khai báo hải quan và đăng ký với các cơ quan hữu quan, không có giá trị thanh toán cho giá trị ghi trong hóa đơn này.</i>
              </td>
            </tr>
          </tbody>
        </table>
        <FormUpdateCIProductDialog
          open={selectedProductIndex >= 0}
          onClose={() => setSelectedProductIndex(-1)}
          initialData={data?.ciproducts[selectedProductIndex]}
          onSave={(newValue) => onChange?.(selectedProductIndex, newValue)}
        />
      </div>
    );
  else return "";
};
export default FormCIForShipProforma;

const FormUpdateCIProductDialog = ({ onClose, onSave, initialData, open }) => {
  const { t } = useTranslation();
  const [input, setInput] = useState();
  const handleChange = (e) => {
    setInput((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleSave = () => {
    onSave?.(input);
    onClose?.();
  };
  useEffect(() => {
    if (!initialData) return;
    setInput(initialData);
  }, [initialData]);
  return (
    <Dialog open={Boolean(open)} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Cập nhật thông tin</DialogTitle>
      <DialogContent style={{ paddingTop: 20 }}>
        <TextField style={{ marginBottom: 15 }} fullWidth name="bl" label="Số hợp đồng" value={input?.bl || ""} onChange={handleChange} />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Ngày hợp đồng")}
          value={input?.bldate}
          onChange={(value) => setInput((prev) => ({ ...prev, bldate: value }))}
          sx={{ marginBottom: "15px", width: "100%" }}
        />
        <TextField style={{ marginBottom: 15 }} fullWidth name="vessel" label="Phương tiện" value={input?.vessel || ""} onChange={handleChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <Button variant="contained" onClick={handleSave}>
          {t("Lưu")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
